import React, { useState } from 'react';
import get from 'lodash/get';
import { Button, Col, Form, Input, Row, Spin } from 'antd';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ForgotPasswordImage from '../../assets/common/login.png';
import { LOGIN } from '../../constants/routes';
import { userMangement } from '../../redux/actions/authActions';

const ForgotPasswordScreen = () => {
  const [loading, setLoading] = useState(false);
  const [forgotPasswordStatus, setForgotPasswordStatus] = useState({
    showEmailInput: true,
    showResetLink: false,
  });
  const [userEmail, setUserEmail] = useState(null);
  const history = useHistory();
  const dispatch = useDispatch();

  const onFinish = (values) => {
    setLoading(true);
    dispatch(userMangement('forgot_password', values))
      .then(() => {
        setLoading(false);
        setUserEmail(get(values, 'email'));
        setForgotPasswordStatus({
          showEmailInput: false,
          showResetLink: true,
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onFinishFailed = () => {};

  return (
    <Spin spinning={loading}>
      <Row>
        <Col span={16} style={{ textAlign: 'center' }}>
          <img src={ForgotPasswordImage} alt="" />
        </Col>

        <Col span={8}>
          <div className="login-container">
            {get(forgotPasswordStatus, 'showEmailInput') && (
              <>
                <div className="heading">Password Recovery</div>
                <div className=" mt-20 text-theme-color">
                  Enter the email you use for Dhandha.app
                </div>
                <div className="login-form" style={{ paddingTop: '7px' }}>
                  <Form
                    name="baisc"
                    layout="vertical"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    requiredMark={false}
                  >
                    <div className="mt-20">
                      <Form.Item
                        label="Email ID"
                        name="email"
                        rules={[
                          {
                            required: true,
                            message: 'Please input your mail',
                          },
                          {
                            type: 'email',
                            message: 'Please input a valid email',
                          },
                        ]}
                      >
                        <Input placeholder="Enter your registered email" />
                      </Form.Item>
                    </div>

                    <div className="mt-60">
                      <Form.Item>
                        <Button type="primary" block htmlType="submit">
                          Continue
                        </Button>
                      </Form.Item>
                    </div>

                    <div className="mt-20">
                      <Button
                        block
                        className="default-btn"
                        onClick={() => {
                          history.push(LOGIN);
                        }}
                      >
                        Back to Login
                      </Button>
                    </div>
                  </Form>
                </div>
              </>
            )}

            {get(forgotPasswordStatus, 'showResetLink') && (
              <>
                <div className="heading">Reset your password</div>
                <div className="login-form">
                  <div className="text-theme-color">
                    Reseting instruction has been sent on <br />
                    <b>{userEmail}</b> <br />
                    Kindly check the email address and proceed further with
                    updating your password
                  </div>

                  <div className="mt-60">
                    <Button
                      type="primary"
                      block
                      onClick={() => {
                        setForgotPasswordStatus({
                          showEmailInput: true,
                          showResetLink: false,
                        });
                      }}
                    >
                      Go to reset page
                    </Button>
                  </div>

                  <div className="mt-20">
                    <Button
                      block
                      className="default-btn"
                      onClick={() => {
                        history.push(LOGIN);
                      }}
                    >
                      Back to Login
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default ForgotPasswordScreen;
